export default [{
  path: '/contract-hr',
  name: 'contractHr',
  meta: {
    layout: 'empty',
  },
  component: () => import('@/views/login/contract-hr')
}]
